export class StructuredDirectivesLine {
    name: string;
    values: string[] = [];
}

export class SectionStructuredDirectives {
    title: string;
    columns: string[] = [];
    lines: StructuredDirectivesLine[] = [];
}

export class SRSectionNavigationRule {
    id: number;
    triggerVariables: string[] = [];
    templateVariables: string;

    findOperator(): string|null {
        let operator: string|null = null;
        if (this.templateVariables != null){
            for (let s of this.templateVariables.split("\n")) {
                let d = s.split("=");
                if (d[0] == 'operator'){
                    operator = d[1];
                    break;
                }
            }
        }
        return operator;
    }
}

export class SRImRange {
    id: number;
    name: string;
    code: string;
    rank: number;
    availableOnMetaRank: number[];

    uiHidden: boolean;
}

export class SRImCategory {
    id: number;
    name: string;
    code: string;
    rank: number;
    ranges: SRImRange[] = [];
    availableOnMetaRank: number[];

    uiHidden: boolean;
}

export class SRIsaDataGroups {
    id: number;
    name: string;
    positon: number;
    datafields: MissionQuestionnaireField[] = [];
    availableOnMetaRank: number[];

}

export class SRSectionRule {
    id: number;
    scope: string;
    triggerVariables: string[] = [];
    templateVariables: string;

    showOnDashboard: boolean;
    message: string;

}

export class SRSectionInputModel {
    sectionId: number;
    name: string;
    directions: string;
    code: string;

    rank: number;


    /**
     * if true the user should enter, in number of minutes the working time
     * dedicated to fulfill the missions of this section
     */
    useTimeTracking: boolean;

    /**
     * if true, then this section should allow the user to fill this section
     * multiple times, and values would be incremented
     */
    allowMultiInputSeries: boolean;

    mandatory: boolean;

    productScanMode: boolean;

    categories: SRImCategory[] = [];
    isaDataGroups: SRIsaDataGroups[] = [];

    /**
     * if true, the user user will be prompted to input this section once more
     * after he just saved an instance
     */
    suggestLoop: boolean;

    /**
     * suggestion of the next section, once this one was sucessfuly saved, it
     * will help to build a full flow of sections
     */
    preferredNextSection: number;

    /**
     * rules for inside a section report
     * @type {any[]}
     */
    rules: SRSectionRule[] = [];

    /**
     * rules between sections
     * @type {any[]}
     */
    sectionNavigationRules: SRSectionNavigationRule[] = [];

    /**
     * structured directives to show in report as information for the agent
     */
    structuredDirectives: SectionStructuredDirectives[];

}

export type QuestionnaireValues = {[key: string]: any};

export class MissionQuestionnaireEnumOption {
    value: number;
    label: string;
    disabled: boolean;
}

export class RuleOperator {
    constructor(private v: string) {

    }

    matches(ruleValue: any, inputValue: any): boolean {

        if (ruleValue == null) return false;
        if (inputValue == null) return false;

        if ('eq' == this.v || 'EQ' == this.v)
            return ruleValue == inputValue;
        if ('ne' == this.v || 'NE' == this.v)
            return ruleValue != inputValue;
        if ('gt' == this.v || 'GT' == this.v)
            return Number.parseFloat(inputValue) > Number.parseFloat(ruleValue);
        if ('gte' == this.v || 'GTE' == this.v)
            return Number.parseFloat(inputValue) >= Number.parseFloat(ruleValue);
        if ('lt' == this.v || 'LT' == this.v)
            return Number.parseFloat(inputValue) < Number.parseFloat(ruleValue);
        if ('lte' == this.v || 'LTE' == this.v)
            return Number.parseFloat(inputValue) <= Number.parseFloat(ruleValue);

        return false;
    }
}

export class MissionQuestionnaireInputRule {
    trigger: string;
    value: any;
    operator: RuleOperator;
    mandatory: Array<string> = [];
    forbidden: Array<string> = [];
    optional: Array<string> = [];

    showOnDashboard: boolean;
    message: string;

}

export class MissionQuestionnaireField {
    id: number;
    code: string;
    shortName: string;
    dataFormat: string;

    fqCode: string;
    rank: number;
    metaRank: number;

    type: string;

    defaultValue: string;

    mandatory: boolean;
    pa: boolean;

    options: Array<MissionQuestionnaireEnumOption> = [];
}

export class MissionQuestionnaireGroup {
    id: number;
    name: string;
    positon: number;
    datafields: Array<MissionQuestionnaireField> = [];
    availableOnMetaRank: Array<number> = [];
}

export class MissionQuestionnaire {
    sectionId: number;
    name: string;
    directions: string;
    code: string;

    rank: number;
    
    groups: Array<MissionQuestionnaireGroup> = [];
    
    extractIsaInputRuleFromDef(r: SRSectionRule): Array<MissionQuestionnaireInputRule> {
        let isaRules: Array<MissionQuestionnaireInputRule> = [];
        if (r.triggerVariables != null){
            for (let t of r.triggerVariables) {
                var iRule = new MissionQuestionnaireInputRule();
                iRule.trigger = 'isa_' + t;
                iRule.message = r.message;
                iRule.showOnDashboard = r.showOnDashboard;
                var tvars = r.templateVariables.split("\r\n");
                for (let l of tvars) {
                    var ll = l.split("=");
                    if (ll[0] == 'operator') {
                        iRule.operator = new RuleOperator(ll[1]);
                    } else if (ll[0] == 'value') {
                        iRule.value = ll[1];
                    } else if (ll[0] == 'mandatory') {
                        iRule.mandatory = ll[1].split('|').map(s => 'isa_' + s);
                    } else if (ll[0] == 'forbidden') {
                        iRule.forbidden = ll[1].split('|').map(s => 'isa_' + s);
                    } else if (ll[0] == 'optional') {
                        iRule.optional = ll[1].split('|').map(s => 'isa_' + s);
                    }
                }
                isaRules.push(iRule);
            }
        }
        return isaRules;
    }
    
}
